export default __webpack_public_path__ + "e6c4cfeb770e54e59766308a1f6447a3.png";